import clsx from 'clsx'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import TooltipButton from '../tooltip-button/TooltipButton'
import { ISelectProposalForm } from '../../modal-select-proposal.types'
import { ArrivalEnum } from '../../../../../lib/graphql'
import { Mixpanel } from '../../../../../utils/Mixpanel'

interface ModalSelectProposalArrivalButtonGroupProps {
  control: Control<ISelectProposalForm, any>
  orderedArrivals: ArrivalEnum[]
  isMobile?: true
}

const translateArrival = ({ arrival }: { arrival: ArrivalEnum }): string => {
  const intl = useIntl()

  switch (arrival) {
    case ArrivalEnum.MORNING:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.morning',
        defaultMessage: 'Matin',
      })
    case ArrivalEnum.BEFORE_LUNCH:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.beforeLunch',
        defaultMessage: 'Déjeuner',
      })
    case ArrivalEnum.EVENING:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.evening',
        defaultMessage: 'Soir',
      })
    default:
      return intl.formatMessage({
        id: 'ui.ArrivalToggleButton.default',
        defaultMessage: "Horaire d'arrivée inconnue",
      })
  }
}

const ModalSelectProposalArrivalButtonGroup = ({
  control,
  orderedArrivals,
  isMobile,
}: ModalSelectProposalArrivalButtonGroupProps) => {
  return (
    <Controller
      control={control}
      name='arrival'
      render={({ field }) => {
        return (
          <div
            className={clsx(s.buttonGroup, { [s.buttonGroupMobile]: isMobile })}
          >
            {orderedArrivals.map((arrival) => {
              const label = translateArrival({ arrival })
              return (
                <TooltipButton
                  key={arrival}
                  label={label}
                  isSelected={arrival === field.value}
                  onClick={() => {
                    Mixpanel.track('Toggle Arrivé', {
                      value: label,
                      data: { name: 'arrival' },
                    })
                    field.onChange(arrival)
                  }}
                />
              )
            })}
          </div>
        )
      }}
    />
  )
}

export default ModalSelectProposalArrivalButtonGroup
